exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleSearch .v-input .v-input__slot{border-radius:33px!important}.v-text-field--box .v-input__slot,.v-text-field--outline .v-input__slot{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;min-height:auto!important}.new-entry{-webkit-animation:difuminar 3s 1;animation:difuminar 3s 1}@-webkit-keyframes difuminar{0%{background-color:#8fbc8f}to{background-color:rgba(143,188,143,0)}}@keyframes difuminar{0%{background-color:#8fbc8f}to{background-color:rgba(143,188,143,0)}}", ""]);

// exports
